import useAccount from '@rhg/hooks/use-account';
import { useActiveCircleId } from '@rhg/hooks/use-active-circle';
import useCircles from '@rhg/hooks/use-circles';
import useAuth from '@rhg/libs/auth0/use-auth';

/**
 * True while an authenticated user's active circle can still arrive: the
 * account has not synced, or no circle is selected and the circle list is
 * still loading. Unauthenticated, failed and empty loads are final no-circle
 * states, so this never holds a user who will not get a circle.
 */
export function useIsCircleInitializing() {
    const { isAuthenticated } = useAuth();
    const { hasActiveCircle } = useActiveCircleId();
    const { isLoading: isAccountLoading } = useAccount();
    const { isLoading: areCirclesLoading } = useCircles();

    return (
        isAuthenticated &&
        (isAccountLoading || (!hasActiveCircle && areCirclesLoading))
    );
}
